import { z } from "zod";

const envSchema = z.object({
  REACT_APP_CLIENT_ID: z.string(),
  REACT_APP_GRANT_TYPE: z.string(),
  REACT_APP_REDIRECT_URI: z.string(),
  REACT_APP_URL_LOGIN: z.string(),
  REACT_APP_API_URL: z.string(),
  // Nome do ambiente exibido no cabeçalho, rodapé e marca d'água das impressões (vazio em produção)
  REACT_APP_AMBIENTE: z.string().default(""),
  PORT: z.coerce.number().default(3001),
});

const _env = envSchema.safeParse(process.env);

if (_env.success === false) {
  console.error("Variavel ambiente invalida", _env.error);

  throw new Error("Variavel ambiente invalida.");
}

export const env = _env.data;
